import { render, staticRenderFns } from "./UploadImagemBannerQuemSomos.vue?vue&type=template&id=59025024&"
import script from "./UploadImagemBannerQuemSomos.vue?vue&type=script&lang=js&"
export * from "./UploadImagemBannerQuemSomos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports